export function buildExpandedPreviewLookup(expandedPreviewItems = []) {
    return Object.fromEntries(
        (expandedPreviewItems ?? [])
            .filter((item) => item?.scheduleId && item?.schedule)
            .map((item) => [item.scheduleId, item.schedule])
    )
}

export function buildExpandedPreviewScheduleList(schedules = [], expandedPreviewLookup = {}) {
    return (schedules ?? []).map((schedule) => ({
        ...schedule,
        ...(expandedPreviewLookup[schedule.id] ?? {}),
    }))
}
